// Formats an ISO date string (e.g. "2026-06-05") as "June 5, 2026" in UTC so
// the rendered value is stable regardless of the server/client timezone.
export function formatDate(dateString: string): string {
	return new Date(`${dateString}T00:00:00Z`).toLocaleDateString('en-US', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
		timeZone: 'UTC',
	})
}
